import React from "react";

function SingleSectionModal({propData,setSearch, search,setData, handleNext, handlePrev, prevValid, nextValid}) {
    var prop_data = propData.data
    // void 0

    return (
        <div>
            <div className="modal fade" id="SingleSelctionModal">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row justify-content-between">
                                <input className="form-control col-10" value={search} placeholder="Search" onChange={e=> setSearch(e.target.value)}/>
                                <button className="btn btn-sm btn-primary" onClick={(e)=> {e.preventDefault(); setSearch('');setData('','')}}>x</button>
                            </div>
                            <div className="table-responsive xrounded card-table">
                                <table className="table items-table table-responsive-sm">
                                    <tbody>
                                        <tr>
                                            <th className="my-0 text-black font-w500 fs-3">Name</th>
                                            <th className="my-0 text-black font-w500 fs-3">Select</th>
                                        </tr>
                                        {prop_data.length > 0 &&
                                            prop_data.map((item, index) => {
                                                var id =  item.id
                                                var name = item.name
                                                return (
                                                    <tr className="alert alert-dismissible border-0">
                                                        <td>
                                                            <div className="media">
                                                                <div className="media-body">
                                                                    <small className="font-w500">
                                                                        <a className="text-primary" href="javascript:void(0);">
                                                                            {id} : {name}
                                                                        </a>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h4 className="my-0 text-black font-w600">
                                                                <div>
                                                                    {<span onClick={(e) => {e.preventDefault();setData(id,name);void 0}}style={{ fontSize: 25, cursor: 'pointer' }}>
                                                                    {propData.id==item.id?"-":"+"}
                                                                        </span>}
                                                                    
                                                                </div>
                                                            </h4>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal"
                                onClick={(e) => {e.preventDefault()}}
                            >OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SingleSectionModal
